import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';

export const countriesSlice = createSlice({
  name: 'countries',
  initialState: {
    list: window.PIH.countries,
    selected: window.PIH.currentCountry,
    master: window.PIH.masterCountry
  },
  reducers: {
  },
});

export const selectCountries = state => state.countries.list;
export const selectCountriesWithNames = state => {
  const countries = state.countries.list.map(id => ({id: id, name: i18n.t(`countries:${id}`)}));

  // Sort by label
  countries.sort((a, b) => a.name.localeCompare(b.name));

  // Put global first
  const globalIndex = countries.findIndex(c => c.id === 'en');
  const global = countries.splice(globalIndex, 1);
  countries.unshift(...global);

  return countries;
};
export const selectCurrentCountry = state => state.countries.selected;
export const selectMasterCountry = state => state.countries.master;

export default countriesSlice.reducer;
